import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LoginPage from './Pages/LoginPage/loginPage';
import SignUpPage from './Pages/SignUpPage/SignUpPage';
import LandingPage from './Pages/LandingPage/landingPage.jsx';
import Verify from  './Pages/VerificationOne/Verify';
import VerifyTwo from  './Pages/VerificationTwo/VerifyTwo';
import VerifyThree from  './Pages/VerificationThree/VerifyThree';
import MainDashboard from './Pages/MainDashboard/MainDasboard';
import './App.css';
import Profile from './Pages/profile/Profile';
import Aboutuspage from './Pages/AboutPage/Aboutpage.jsx';
import TermsAndCondition from './Pages/termscondPage/Termscon.jsx';
import FAQ from './Pages/Askequestionpage/askequestion.jsx';
import Privacy from './Pages/Privacypage/Privacy.jsx';
import Messages from './Pages/MainDashboard/Messages';



function App() {
  return (
    <Router>
      <React.Fragment>
      <Routes>
        <Route path='/login' element={<LoginPage />}></Route>
        <Route path='/signUp' element={<SignUpPage />}></Route>        
        <Route path='/' element={<LandingPage />}></Route>    
        <Route path='/verify' element={<Verify />} exact></Route>
        <Route path='/verifyStep2' element={<VerifyTwo />} exact></Route>
        <Route path='/verifyStep3' element={<VerifyThree />} exact></Route>
        <Route path='/profile' element={<Profile />} exact></Route>
        <Route path='/aboutpage' element={< Aboutuspage />} exact></Route>
        <Route path='/termscon' element={<TermsAndCondition/>} exact></Route>
        <Route path="/dashboard" element={<MainDashboard />}></Route>
        <Route path="/faq" element={<FAQ />}></Route>
        <Route path="/privacy" element={<Privacy />}></Route>
        <Route path="/messages" element={<Messages />}></Route>
        </Routes>
      </React.Fragment>
    </Router>
  );
}

export default App;



